import { Component, type ReactNode, type ErrorInfo } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="flex min-h-[50vh] items-center justify-center p-xl">
          <div className="text-center">
            <p className="font-display text-lg text-ink">Coś poszło nie tak</p>
            <p className="mt-xs font-body text-sm text-ink-light">Spróbuj odświeżyć stronę.</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-md rounded bg-botanical px-md py-xs font-label text-sm text-paper"
            >
              Odśwież
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
